var o=function(e){return e.CHOCOLATES="chocolates",e.FLOWERS="flowers",e.DESSOUS="dessous",e.PERFUME="perfume",e}({});export{o as Gift};